export const HDBLinks = { 
  

  eligibility_msg:{
    eligible_condition: "https://www.hdb.gov.sg/residential/living-in-an-hdb-flat/changing-owners-occupiers/change-in-ownership/change-in-flat-ownership/eligibility"
  },

  apply_hle_url:"https://services2.hdb.gov.sg/webapp/BP27AWHLEApplication/BP27SHome",
  
  //Start Application Declaration
  supporting_documents: "https://www.hdb.gov.sg/-/media/managing-my-home/home-ownership/change-of-flat-owners-or-occupiers/change-in-flat-ownership-not-through-a-sale/application-process/documents-to-bring.pdf",
  private_statement: "https://www.hdb.gov.sg/privacy-statement",
  terms_of_use: "https://www.hdb.gov.sg/terms-of-use",
  process_coo: "https://www.hdb.gov.sg/managing-my-home/home-ownership/change-of-flat-owners-or-occupiers/change-in-flat-ownership-not-through-a-sale/application-process",
  terms_and_conditions: "https://hdb.gov.sg/cs/infoweb/-/media/doc/HMG/change-in-flat-ownership-terms-and-conditions.pdf",  


  information_for_proposed_owners:{
    applying_subsidised_flat: "https://www.hdb.gov.sg/cs/infoweb/residential/buying-a-flat/conditions-after-buying",
    obtaining_hdb_loan: "https://www.hdb.gov.sg/cs/infoweb/residential/buying-a-flat/understanding-your-eligibility-and-housing-loan-options/housing-loan-options",
    obtaining_bank_loan: "https://www.hdb.gov.sg/cs/infoweb/residential/buying-a-flat/understanding-your-eligibility-and-housing-loan-options/housing-loan-options/housing-loan-from-financial-institutions",
    spr_household: "https://www.hdb.gov.sg/cs/infoweb/residential/living-in-an-hdb-flat/acquiring-private-property",
    stamp_duty: "https://www.iras.gov.sg/taxes/stamp-duty/for-property",
  },

  information_for_current_owners:{
    cpf_refund: "https://www.cpf.gov.sg/member/home-ownership/using-your-cpf-to-buy-a-home/cpf-refund-when-selling-or-transferring-property",
    buy_hdb_second_hdb_loan: "https://www.hdb.gov.sg/cs/infoweb/residential/buying-a-flat/understanding-your-eligibility-and-housing-loan-options/housing-loan-options/housing-loan-from-hdb",
    buy_another_flat: "https://www.hdb.gov.sg/cs/infoweb/residential/buying-a-flat/understanding-your-eligibility-and-housing-loan-options/flat-and-grant-eligibility",
    enjoy_subsidy: "https://www.hdb.gov.sg/cs/infoweb/residential/buying-a-flat/conditions-after-buying",
    stamp_duty: "https://www.iras.gov.sg/taxes/stamp-duty/for-property/selling-or-disposing-property/seller's-stamp-duty-(ssd)-for-residential-property",
  },
  
  other_information:{
    stamp_fee: "https://www.iras.gov.sg/taxes/stamp-duty/for-property/basics-of-stamp-duty-for-property/learning-the-basics-for-properties"
  },

  //A2
  finance_checking: "https://www.hdb.gov.sg/cs/infoweb/residential/living-in-an-hdb-flat/changing-owners-occupiers/change-in-ownership/change-in-flat-ownership",
  
  hle_application: "#",

  //A3
  median_resale_prices: "https://www.hdb.gov.sg/residential/selling-a-flat/overview/resale-statistics",
  joint_tenancy: "https://www.hdb.gov.sg/cs/infoweb/residential/living-in-an-hdb-flat/changing-owners-occupiers/change-in-ownership/change-in-flat-ownership/manner-of-holding",
  tenancy_in_common: "https://www.hdb.gov.sg/cs/infoweb/residential/living-in-an-hdb-flat/changing-owners-occupiers/change-in-ownership/change-in-flat-ownership/manner-of-holding",
  uen: "https://www.uen.gov.sg/ueninternet/faces/pages/uenSrch.jspx",

  // Financial calculator
  cpf_service: "https://www.cpf.gov.sg/eSvc/Web/PortalServices/CpfMemberPortalServices",

  // Miscellaneous
  feedback: "https://services2.hdb.gov.sg/webapp/BF12AWFeedback/BF12SFrontController?service=ServiceFeedback&operation=createFeedback"

}